import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spin as Hamburger } from "hamburger-react";
import { FaBars } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navColor, setNavColor] = useState(false);

  const changeNavColor = () => {
    if (window.scrollY >= 100) {
      setNavColor(true);
    } else {
      setNavColor(false);
    }
  };
  window.addEventListener("scroll", changeNavColor);

  return (
    <div className={navColor ? "header header-bg-color" : "header"}>
      <Link to={"/"}>
        <h1>Daves Portfolio</h1>
      </Link>
      <ul className={menuOpen ? "navbar-menu active" : "navbar-menu"}>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/projects">Projects</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>

      <div className="hamburger">
        {menuOpen && (
          <Hamburger
            label="Show menu"
            toggled={menuOpen}
            toggle={setMenuOpen}
          />
        )}
        {!menuOpen && (
          <Hamburger
            label="Show menu"
            toggled={menuOpen}
            toggle={setMenuOpen}
          />
        )}
      </div>
    </div>
  );
};

export default Navbar;
